$(function () {
    const base_url = $("meta[name='baseUrl']").attr("content");
    let csrf_name = $("#csrf").attr("name");

    $("#show_eye,#hide_eye").click(function (e) {
        const x = document.getElementById("userpassword");
        const show_eye = document.getElementById("show_eye");
        const hide_eye = document.getElementById("hide_eye");
        hide_eye.classList.remove("d-none");
        if (x.type === "password") {
            x.type = "text";
            show_eye.style.display = "none";
            hide_eye.style.display = "block";
        } else {
            x.type = "password";
            show_eye.style.display = "block";
            hide_eye.style.display = "none";
        }
    });

    $(".forget-passwrod").click(function (e) {
        e.preventDefault();

        $(".form-signin").fadeOut("fast", function () {
            $(this).addClass("d-none");
        });

        $(".form-password").fadeIn("fast", function () {
            $(this).removeClass("d-none");
        });
    });

    $("#login").click(function (e) {
        e.preventDefault();

        $(".form-signin").fadeIn("fast", function () {
            $(this).removeClass("d-none");
        });

        $(".form-password").fadeOut("fast", function () {
            $(this).addClass("d-none");
        });
    });

    $(".form-signin").submit(async function (e) {
        let count = await $().validate_form($("#form-signin"));

        if (count.check > 0) {
            $().toastEvent({
                heading: "แจ้งเตือน",
                icon: "error",
                text: "กรุณากรอกข้อมูลให้ครบถ้วน",
                position: "top-right",
            });
        } else {
            $().setLoading("start");
            try {
                let response = await axios.post("login/submit", {
                    username: $("#identity").val(),
                    password: $("#userpassword").val(),
                    rememberMe: $("#rememberMe").is(":checked"),
                });

                // ถ้า requires2FA → แสดง form 2FA
                if (response.data && response.data.requires2FA) {
                    Swal.close();
                    $("#temp-token").val(response.data.tempToken);
                    $(".form-signin").fadeOut("fast", function () {
                        $(this).addClass("d-none");
                    });
                    $(".form-2fa").fadeIn("fast", function () {
                        $(this).removeClass("d-none");
                        $("#totp-login-code").focus();
                    });
                    return;
                }
            } catch (error) {
                let errMsg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
                if (error.response.data.message) {
                    errMsg = error.response.data.message;
                }
                Swal.close();
                Swal.fire('Error',errMsg,'error')
                console.error(error);
                return;
            }
            await offerPasskeySetupThenGoHome();
        }
    });

    $("#btn-resetpass").click(async function () {
        let count = await $().validate_form($("#frm-password"));

        if (count.check > 0) {
            $().toastEvent({
                heading: "แจ้งเตือน",
                icon: "error",
                text: "รูปแบบอีเมลไม่ถูกต้อง",
                position: "top-right",
            });
        } else {
            $().setLoading("start");
            $.ajax({
                type: "POST",
                url: base_url + "login/ajaxforgotpassword",
                data: {
                    email: $("#email").val().trim(),
                    [csrf_name]: $("#csrf").val(),
                },
                dataType: "json",
                success: function (rs) {
                    $("#csrf").val(rs.token);
                    if (rs.status) {
                        $().setLoading("close");
                        $().toastEvent({
                            heading: "แจ้งเตือน",
                            icon: "info",
                            text: rs.msg,
                            position: "top-right",
                        });
                        $("#login").trigger("click");
                        $("#email").val("");
                    }
                },
            });
        }
    });

    $("#identity,#userpassword").keyup(function (e) {
        if (e.keyCode == 13) {
            $("#submit-login").trigger("click");
        }
    });

    $("#email").keyup(function (e) {
        if (e.keyCode == 13) {
            $("#btn-resetpass").trigger("click");
        }
    });

    // Toggle OTP / Recovery Code mode
    let isRecoveryMode = false;
    $("#toggle-recovery-mode").click(function (e) {
        e.preventDefault();
        isRecoveryMode = !isRecoveryMode;
        if (isRecoveryMode) {
            $("#otp-mode").addClass("d-none");
            $("#recovery-mode").removeClass("d-none");
            $("#recovery-login-code").focus();
            $(this).html('<i class="fa fa-shield-halved me-1"></i> ใช้ Authenticator App');
        } else {
            $("#recovery-mode").addClass("d-none");
            $("#otp-mode").removeClass("d-none");
            $("#totp-login-code").focus();
            $(this).html('<i class="fa fa-key me-1"></i> ใช้ Recovery Code');
        }
    });

    // 2FA form submit
    $(".form-2fa").submit(async function (e) {
        let totpCode = "";
        let recoveryCode = "";

        if (isRecoveryMode) {
            recoveryCode = $("#recovery-login-code").val().trim().toUpperCase();
            if (!recoveryCode || recoveryCode.length !== 8) {
                $().toastEvent({
                    heading: "แจ้งเตือน",
                    icon: "error",
                    text: "กรุณาใส่ Recovery Code 8 หลัก",
                    position: "top-right",
                });
                return;
            }
        } else {
            totpCode = $("#totp-login-code").val().trim();
            if (!/^\d{6}$/.test(totpCode)) {
                $().toastEvent({
                    heading: "แจ้งเตือน",
                    icon: "error",
                    text: "กรุณาใส่รหัส 6 หลัก",
                    position: "top-right",
                });
                return;
            }
        }

        $().setLoading("start");
        try {
            await axios.post("login/verify_2fa", {
                tempToken: $("#temp-token").val(),
                totpCode: isRecoveryMode ? recoveryCode : totpCode,
                rememberMe: $("#rememberMe").is(":checked"),
            });
        } catch (error) {
            let errMsg = isRecoveryMode ? "Recovery Code ไม่ถูกต้องหรือถูกใช้แล้ว" : "รหัส OTP ไม่ถูกต้อง";
            if (error.response && error.response.data && error.response.data.message) {
                errMsg = error.response.data.message;
            }
            Swal.close();
            Swal.fire("Error", errMsg, "error");
            console.error(error);
            return;
        }
        await offerPasskeySetupThenGoHome();
    });

    // กลับหน้า login จาก 2FA
    $("#back-to-login").click(function (e) {
        e.preventDefault();
        $(".form-2fa").fadeOut("fast", function () {
            $(this).addClass("d-none");
        });
        $(".form-signin").fadeIn("fast", function () {
            $(this).removeClass("d-none");
        });
        $("#totp-login-code").val("");
        $("#recovery-login-code").val("");
        // reset to OTP mode
        isRecoveryMode = false;
        $("#recovery-mode").addClass("d-none");
        $("#otp-mode").removeClass("d-none");
        $("#toggle-recovery-mode").html('<i class="fa fa-key me-1"></i> ใช้ Recovery Code');
    });

    // Enter key ใน TOTP/Recovery login input
    $("#totp-login-code, #recovery-login-code").keyup(function (e) {
        if (e.keyCode == 13) {
            $(".form-2fa").submit();
        }
    });

    // ===== Passkey login =====
    const webauthn = window.SimpleWebAuthnBrowser;
    if (webauthn && webauthn.browserSupportsWebAuthn()) {
        $("#passkey-divider, #btn-passkey-login, #passkey-hint").removeClass("d-none");
    }

    const PASSKEY_DEVICE_KEY = "passkey_registered_on_this_device";
    const PASSKEY_SNOOZE_KEY = "passkey_setup_snoozed_until";
    const PASSKEY_SNOOZE_MS = 14 * 24 * 60 * 60 * 1000;

    // passkey แบบ platform ผูกกับเครื่องที่ลงทะเบียน เครื่องที่ไม่เคยลงทะเบียนจะกดปุ่ม passkey
    // แล้วเจอ NotAllowedError เสมอ — ต้องพาผู้ใช้ตั้งค่าตั้งแต่ตอนที่เพิ่ง login สำเร็จบนเครื่องนั้น
    function shouldOfferPasskeySetup({ supported, platformAvailable, registeredOnThisDevice, snoozedUntil, now }) {
        if (!supported || !platformAvailable || registeredOnThisDevice) {
            return false;
        }
        const until = Number(snoozedUntil);
        if (Number.isFinite(until) && until > now) {
            return false;
        }
        return true;
    }

    // WebAuthn บอกว่ากุญแจที่ใช้ยืนยันมาจากไหน — cross-platform คือยืมจากเครื่องอื่น (สแกน QR
    // หรือ security key) ส่วน platform คือกุญแจที่ฝังอยู่ในเครื่องที่กำลังใช้อยู่
    function usedKeyFromAnotherDevice(assertion) {
        return Boolean(assertion) && assertion.authenticatorAttachment === "cross-platform";
    }

    function readLocal(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function writeLocal(key, value) {
        try {
            window.localStorage.setItem(key, value);
        } catch (e) {
            /* โหมดส่วนตัวหรือปิด storage — แค่ไม่จำค่า ไม่ต้องขวางการ login */
        }
    }

    function markPasskeyOnThisDevice() {
        writeLocal(PASSKEY_DEVICE_KEY, "1");
    }

    async function offerPasskeySetupThenGoHome() {
        const goHome = () => {
            window.location = base_url + "home";
        };

        let platformAvailable = false;
        try {
            platformAvailable = Boolean(webauthn && (await webauthn.platformAuthenticatorIsAvailable()));
        } catch (e) {
            platformAvailable = false;
        }

        const offer = shouldOfferPasskeySetup({
            supported: Boolean(webauthn && webauthn.browserSupportsWebAuthn()),
            platformAvailable: platformAvailable,
            registeredOnThisDevice: readLocal(PASSKEY_DEVICE_KEY) === "1",
            snoozedUntil: readLocal(PASSKEY_SNOOZE_KEY),
            now: Date.now(),
        });

        if (!offer) {
            goHome();
            return;
        }

        Swal.close();
        const result = await Swal.fire({
            title: "ตั้งค่าเข้าสู่ระบบด้วยการสแกนบนเครื่องนี้",
            text: "ครั้งหน้าใช้ Face ID หรือลายนิ้วมือของเครื่องนี้เข้าสู่ระบบได้เลย ไม่ต้องพิมพ์รหัสผ่านและไม่ต้องสแกน QR จากเครื่องอื่น",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "เปิดใช้งาน",
            cancelButtonText: "ไว้ทีหลัง",
        });

        if (!result.isConfirmed) {
            writeLocal(PASSKEY_SNOOZE_KEY, String(Date.now() + PASSKEY_SNOOZE_MS));
            goHome();
            return;
        }

        try {
            const optRes = await axios.post("profile/passkey_register_options");
            const options = optRes.data && optRes.data.data;
            if (!options) throw new Error("ไม่สามารถเริ่มกระบวนการได้");

            const attResp = await webauthn.startRegistration({ optionsJSON: options });
            await axios.post("profile/passkey_register_verify", {
                response: attResp,
                deviceName: navigator.userAgent.includes("Mobile") ? "มือถือของฉัน" : "เครื่องนี้",
            });

            markPasskeyOnThisDevice();
            await Swal.fire("ตั้งค่าเรียบร้อย", "ครั้งหน้าเข้าสู่ระบบด้วยการสแกนบนเครื่องนี้ได้เลย", "success");
        } catch (err) {
            writeLocal(PASSKEY_SNOOZE_KEY, String(Date.now() + PASSKEY_SNOOZE_MS));
            await Swal.fire("ยังเปิดใช้งานไม่ได้", getPasskeyErrorMessage(err), "info");
        }

        goHome();
    }

    function getPasskeyErrorMessage(err) {
        if (err && err.name === "NotAllowedError") {
            return "ยกเลิกการสแกน หรือไม่พบ Passkey ที่ลงทะเบียนไว้บนเครื่องนี้ — ลองเพิ่ม Passkey ใหม่ที่ Profile > Security";
        }
        if (err && err.response && err.response.data && err.response.data.message) {
            return err.response.data.message;
        }
        if (err && err.message) {
            return err.message;
        }
        return "Passkey login ไม่สำเร็จ";
    }

    $("#btn-passkey-login").click(async function () {
        if (!webauthn) return;
        try {
            $().setLoading("start");
            const email = ($("#identity").val() || "").trim();
            const optRes = await axios.post("login/passkey_options", email ? { email } : {});
            const payload = optRes.data;
            if (!payload || !payload.options) throw new Error("ไม่สามารถเริ่ม passkey login ได้");

            Swal.close();
            const assertion = await webauthn.startAuthentication({ optionsJSON: payload.options });

            $().setLoading("start");
            await axios.post("login/passkey_verify", {
                response: assertion,
                challengeKey: payload.challengeKey,
                rememberMe: $("#rememberMe").is(":checked"),
            });
            // ยืมกุญแจจากเครื่องอื่นผ่าน QR (cross-platform) แปลว่าเครื่องนี้ยังไม่มีกุญแจของตัวเอง
            // ครั้งหน้าก็จะต้องสแกน QR อีก — ชวนตั้งค่าบนเครื่องนี้เลยตอนที่เพิ่งผ่านความยุ่งยากมา
            if (usedKeyFromAnotherDevice(assertion)) {
                await offerPasskeySetupThenGoHome();
                return;
            }

            markPasskeyOnThisDevice();
            window.location = base_url + "home";
        } catch (err) {
            Swal.close();
            const msg = getPasskeyErrorMessage(err);
            Swal.fire("ผิดพลาด", msg, "error");
        }
    });
});
